<template>
    <div class="footer-container">
        <div class="footer-content">
            <p>324 S. Beverly Drive, Suite 945, Beverly Hills, CA 90212</p>
            <p style="text-wrap: nowrap; flex-direction: row;">
                <span v-if="!isMobileView">
                    <span>O:</span><span><a href="tel:%20(310)%20247-9500">(310) 247-9500</a></span>
                    <span>&nbsp;&nbsp;&nbsp; F:</span><span>(310) 247-0109&nbsp;&nbsp;&nbsp;</span>
                    <span>E:</span><span><a href="mailto:info@perlmanlaw.com">info@perlmanlaw.com</a></span>
                </span>
                <span v-else
                    style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <p style="display: flex; flex-direction: row;"><span>O:</span><span><a
                                href="tel:%20(310)%20247-9500">(310) 247-9500</a></span></p>
                    <p style="display: flex; flex-direction: row;"><span>F:</span><span>(310) 247-0109</span></p>
                    <p style="display: flex; flex-direction: row;"><span>E:</span><span><a
                                href="mailto:info@perlmanlaw.com">info@perlmanlaw.com</a></span></p>
                </span>
            </p>
            <p>©2026 Perlman Law. All Rights Reserved</p>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const isMobileView = ref(window.innerWidth < 768)
const innerWidth = ref(window.innerWidth)

const handleResize = () => {
    innerWidth.value = window.innerWidth
    isMobileView.value = window.innerWidth < 768
}

let handleResizeFunc = null

onMounted(() => {
    handleResizeFunc = handleResize
    isMobileView.value = window.innerWidth < 768
    window.addEventListener('resize', handleResizeFunc)
})

onBeforeUnmount(() => {
    try {
        if (handleResizeFunc) {
            window.removeEventListener('resize', handleResizeFunc)
        }
    } catch (error) {
        console.warn(error)
    }
})

</script>

<style scoped>
.footer-container {
    background-color: #fefefe;
    position: relative;
    z-index: 10;
    margin: 25px 0 15px 0;
    padding: 0 20px;
}

.footer-content {
    position: relative;
    display: flex;
    flex-direction: column;
}

.footer-content>p,
.footer-content>p>span {
    flex-direction: row;
    display: inline-flex;
}

.footer-content p a,
.footer-content p span,
.footer-content p span a,
.footer-content p span {
    display: inline-flex;
    flex-direction: row;
}

.footer-content p {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-style: normal;
    font-family: var(--font-family-body);
    color: var(--text-dark);
    padding: 0;
    margin: 0;
}

.footer-content a,
.footer-content a:link,
.footer-content a:visited,
.footer-content a:active {
    cursor: pointer;
    text-decoration: none;
    color: var(--nav-links-hover-dark);
    font-family: var(--nav-links-font-family);
}

.footer-content a:hover {
    text-decoration: none;
    color: var(--nav-links-hover2-dark);
}
</style>